import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import _ from 'lodash';
import styled from 'styled-components';
import { HBox } from '../../../../components/Box';
import { BaseComponent } from '../../../../components/BaseComponent';
import { BORDER_GREY_LIGHT } from '../../../../vars';
import CheckboxComponent from '../../../../containers/App/Components/Checkbox/Checkbox';
import styles from './OneTimeProduct.module.css';

const STATE = {};

class AddOneTimeProductComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      selectedCompany: props?.vehicle?.buyingCompany ?? null,
    });
  }

  componentDidMount() {}

  render() {
    return (
      <div onClick={this.props.onClick}>
        <div className={styles.container}>
          <div className={styles.checkboxContainer}>
            <input
              className="form-control"
              name="description"
              type="text"
              id="readOnlyInput"
              readOnly
              placeholder="product name"
              value={this.props.value.description}
              onChange={evt => {
                this.onInputChange(evt);
              }}
            />
          </div>

          <div className={styles.hBox}>
            <div className={styles.input}>
              <input
                className="form-control"
                id="readOnlyInput"
                readOnly
                name="one_time"
                placeholder="quantity"
                type="text"
                value={this.props.value.one_time}
                onChange={evt => {
                  this.onInputChange(evt);
                }}
              />
            </div>

            <div className={styles.inputPrice}>
              <input
                className="form-control"
                id="readOnlyInput"
                readOnly
                name="price"
                type="text"
                placeholder="price"
                value={this.props.value.price}
                onChange={evt => {
                  this.onInputChange(evt);
                }}
              />
              <div className={styles.decoration}>€</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {};

function mapDispatchToProps(dispatch, ownProps) {
  return {};
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const OneTimeProduct = compose(withConnect, withRouter, injectIntl)(AddOneTimeProductComp);
